import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <div className="flex items-center gap-4" data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="font-heading text-sm font-extrabold tracking-[0.3em] text-gold">
      {index}
    </span>
    <span className="h-px w-12 bg-gold/40" />
    <span className="text-xs font-bold uppercase tracking-[0.3em] text-white/50">
      {label}
    </span>
  </div>
);
